import { axiosRubyClient as api } from '@/util/axios/axiosClient';

export interface JobWorkerStatus {
  id: number;
  worker_id: number;
  status: string;
  removal_type: string | null;
  is_late_drop: boolean;
  suspension_type: string | null;
}

export interface JobWorkerStatusesResponse {
  success: boolean;
  data: JobWorkerStatus[];
}

export interface JobQualityGateData {
  quality_gate_disabled: boolean;
  quality_gate_disabled_reason: string | null;
  quality_gate_disabled_at: string | null;
  customer_quality_gate_enabled: boolean;
}

export const JobsAPI = {
  getJobWorkerStatuses: async (
    jobId: number,
  ): Promise<JobWorkerStatusesResponse> => {
    const response = await api.get<JobWorkerStatusesResponse>(
      `/api/admin/jobs/${jobId}/worker_statuses`,
    );
    return response.data;
  },

  getQualityGateData: async (jobId: string): Promise<JobQualityGateData> => {
    const response = await api.get(`/api/admin/jobs/${jobId}`);
    const job = response.data.data;
    return {
      quality_gate_disabled: job.quality_gate_disabled ?? false,
      quality_gate_disabled_reason: job.quality_gate_disabled_reason ?? null,
      quality_gate_disabled_at: job.quality_gate_disabled_at ?? null,
      customer_quality_gate_enabled:
        job.account?.customer?.quality_gate_enabled ?? false,
    };
  },

  getCustomerQualityGate: async (customerId: string): Promise<boolean> => {
    const response = await api.get(`/api/admin/customers/${customerId}`);
    return response.data.data.quality_gate_enabled ?? false;
  },

  getQualityGateActiveJobIds: async (
    jobIds: number[],
  ): Promise<Set<number>> => {
    if (jobIds.length === 0) return new Set();
    const response = await api.post('/api/admin/jobs/quality_gate_active', {
      job_ids: jobIds,
    });
    const ids: number[] = response.data?.data?.active_job_ids ?? [];
    return new Set<number>(ids);
  },
};
